import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { DataService, Request, AuthRequest } from '../services/data-service';
import { Api } from '../services/api';
import { FormatBytes } from '../machines/machine-schemas';


const Stages = {
	Upload:"Upload", Ready:"Ready",
	InProcess:"InProcess", Done:"Done"
}

@inject(DataService, Api, Router)
export class CreateDataset {
	/** Component methods **/
	constructor(ds, api, router){
		this.ds		= ds;
		this.api	= api;
		this.formatBytes = FormatBytes;// Constant
		this.router = router;
		this.file	= "";

		this.Stages	= Stages
		this.stage	= Stages.Ready
	}

	activate(params){ this.id = params.uid }

	attached(){
		window.setTimeout( () => { this.init(); }, 300);
	}

	init(){
		// Init user
	}

	/** API Calls **/

	requestStorageQuota(fileSize){
		// Subscription token
		let subsToken		= this.ds.user.subs;
		let uid				= this.id; // From activate params
		let request			= new AuthRequest("/api/v2/users/"+uid+"/usage-storage-token", "POST");

		let body			= { uid: uid, size:fileSize };
		request.body		= JSON.stringify(body);
		// Add subscription header
		request.headers["Authorization"] = "Bearer " + subsToken; // Bearer + token
		return this.api.post(request);
	}
	

	/** Action methods **/

	// Promise upload File

	uploadFile(){
		return new Promise(resolve => {
			// Create dataset document
			let dataset_document = {
				name	: this.file.name,
				size	: this.file.size,
				uid		: this.ds.user.uid,
				type	: "source"
			};

			// Create request
			let request	= new Request("/api/v2/datasets/", "POST");
			// Add AccesToken Auth Header
			request.headers["Authorization"] = "Bearer " + this.accessToken; // Bearer + token

			// Read file
			this.readFile(this.file).then(f => {

				if(f){
					let file		= f;
					let body		= { "dataset": dataset_document, "file":file };
					request.body 	= JSON.stringify(body);
					return this.api.post(request);
				}
				else{
					return new Promise(resolve => { resolve(400)});
				}

			})
			.then(response => {
				// Perform summary
				let id 		= response.data._id
				let req 	= new Request( "/api/v2/summary/","POST");
				let body 	= { dataset:response.data };
				req.body 	= JSON.stringify(body)
				// POST summary
				return this.api.post(req);
			})
			.then(res => {
				//console.log("summary =>", res);
				resolve(res);
			})
			.catch( (e) => {console.log("Invalid request => ", e);});
			
		})
		.catch( (e) => { console.log("faild upload => ", e);});
	}


	/** File upload **/
	_uploadFile(){

		// Response dataset
		//let response_dataset;
		
		let dataset_document = {
			name	: this.file.name,
			size	: this.file.size,
			uid		: this.ds.user.uid,
			type	: "source"
		};

		let request	= new Request("/api/v2/datasets/", "POST");

		// Add AccesToken Auth Header
		request.headers["Authorization"] = "Bearer " + this.accessToken; // Bearer + token
		
		this.readFile(this.file).then(f => {
			if(f){
				let file		= f;
				let body		= { "dataset": dataset_document, "file":file };
				request.body 	= JSON.stringify(body);
				return this.api.post(request);
			}
			else{
				return new Promise(resolve => { resolve(400)});
			}
		})
		.then(response => {
			// console.log("response: ", response);
			// Perform summary
			// Dataset id
			let id = response.data._id
			let req 	= new Request( "/api/v2/summary/","POST");
			let body 	= { dataset:response.data };
			req.body 	= JSON.stringify(body)
			// Setup response dataset <- dataset document
			//response_dataset = response.data;
			// POST summary
			return this.api.post(req);
		})
		.then(res => {
			//console.log("summary =>", res);
			// Update Machine
		});
	}

	readFile(file){
		if(file){
			let fr = new FileReader();
			// Read as URL
			// Add event listener
			fr.addEventListener('loadstart', this.frChangeStatus('Start loading'));
			fr.addEventListener('load', this.frChangeStatus('Loaded'));
			fr.addEventListener('loadend', this.frLoaded);
			fr.addEventListener('progress', this.frSetProgress);
			fr.addEventListener('error', this.frErrorHandler);
			fr.addEventListener('abort', this.frChangeStatus('Interrupted'));

			return new Promise(resolve => {
				fr.readAsDataURL(file);
				fr.onload = () => { resolve(fr.result);};
			});
		}
		else{
			return new Promise(resolve => { resolve(null);});
		}
	}
	
	onSelectFile($event){this.file = $event.target.files[0];}
	frChangeStatus(status){console.log("status: ", status);}

	frLoaded(e){
		let file = e.target
		this.fileStream = file.result;
	}
	frSetProgress(e){}
	frErrorHandler(e){}


	/** Custom methods **/
	_done(){
		this.uploadFile();
		window.setTimeout( () => {
			this.router.navigateToRoute('datasets', { uid:this.id })
		}, 1000);
		
	}

	done(){
		// Change stage status
		this.stage = Stages.InProcess;

		// Get Resources access Token
		let fileSize = this.file.size // in bytes
		this.requestStorageQuota(fileSize).then(responseQuota => {
			let status = responseQuota.status;
			if(status === 200){
				// Operational Access Token OperAccesToken
				let accessToken 	= responseQuota.data.oper_token; 
				this.accessToken 	= accessToken;
				// Continue with operation
				return this.uploadFile();
			}
		})
		.then(res => {
			// Remove datasets to force reload
			this.ds.app_data.datasets = null;
			if(res.status === 200){ this.router.navigateToRoute('datasets', { uid:this.id }) }
		});
		// Upload file (POST)

	}
}
